import { render } from "./main-page.vue?vue&type=template&id=3303e83e&scoped=true"
import script from "./main-page.vue?vue&type=script&lang=js"
export * from "./main-page.vue?vue&type=script&lang=js"

import "./main-page.vue?vue&type=style&index=0&id=3303e83e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3303e83e"]])

export default __exports__